import { v4 as uuid } from 'uuid';
import { COMMAND_CLOCK_IN, COMMAND_CLOCK_OUT, ClockCommand } from '@@handlers';
import {
  AttendanceActionDto,
  AttendanceEventDto,
  CurrentEmployeeModel,
} from '@@api';
import { RECORD_ID, getStorageService } from '@@common';

// Add to common module
type SubmitCommand<TCommand> = (
  command: TCommand,
  postSubmit?: (commandResult: unknown | null) => Promise<unknown> | null,
) => Promise<unknown>;

async function clockAction(
  submitCommand: SubmitCommand<ClockCommand>,
  actions: AttendanceActionDto[],
  typeId: string,
  refresh?: () => Promise<unknown>,
): Promise<void> {
  const action = actions.find((x) => x.typeId === typeId);
  const ev: AttendanceEventDto = {
    id: uuid(),
    isConfirmed: false,
    timestamp: new Date().toISOString(),
    typeId,
    typeName: action?.typeName,
  };

  await submitCommand(
    {
      commandType: action?.isClockIn ? COMMAND_CLOCK_IN : COMMAND_CLOCK_OUT,
      commandTitle: action?.isClockIn ? COMMAND_CLOCK_IN : COMMAND_CLOCK_OUT,
      id: uuid(),
      typeId: ev.typeId,
      eventTimestamp: ev.timestamp,
    } as ClockCommand,
    async () => {
      await getStorageService().upsert<CurrentEmployeeModel>(
        RECORD_ID.USER_ATTENDANCE_STATUS,
        (v) =>
          ({
            ...v,
            lastEvent: ev,
            events: [ev, ...(v?.events ?? [])],
          } as CurrentEmployeeModel),
      );
      // refresh the data (if online)
      if (refresh) {
        await refresh();
      }
    },
  );
}

export default clockAction;
